(function () {
  'use strict';

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('lb-anim');
  }

  var SELECTOR = 'main h1, main h2, main h3, main .product-card, main .rte, main .hrev__card, footer h2, footer h3';

  function mark(root) {
    var els = root.querySelectorAll(SELECTOR);
    els.forEach(function (el, i) {
      if (el.classList.contains('lb-reveal')) return;
      el.classList.add('lb-reveal');
      if (el.classList.contains('product-card') || el.classList.contains('hrev__card')) {
        el.style.transitionDelay = (i % 4) * 70 + 'ms';
      }
    });
    return els;
  }

  function revealAll(els) {
    els.forEach(function (el) { el.classList.add('lb-in'); });
  }

  function initReveal() {
    if (!document.documentElement.classList.contains('lb-anim')) return;
    var els = mark(document);
    if (!('IntersectionObserver' in window)) {
      revealAll(els);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lb-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) { io.observe(el); });

    requestAnimationFrame(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) el.classList.add('lb-in');
      });
    });

    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        var fresh = mark(document);
        fresh.forEach(function (el) {
          if (!el.classList.contains('lb-in')) io.observe(el);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Safety net: reveal anything scrolled into view even if IO misses it
    // (e.g. content clipped out of .page-wrapper after an anchor jump).
    var sweepTick = false;
    function sweep() {
      sweepTick = false;
      var pendingEls = document.querySelectorAll('.lb-reveal:not(.lb-in)');
      for (var i = 0; i < pendingEls.length; i++) {
        if (pendingEls[i].getBoundingClientRect().top < window.innerHeight * 0.94) {
          pendingEls[i].classList.add('lb-in');
        }
      }
    }
    function scheduleSweep() {
      if (!sweepTick) {
        sweepTick = true;
        requestAnimationFrame(sweep);
      }
    }
    window.addEventListener('scroll', scheduleSweep, { passive: true });
    window.addEventListener('resize', scheduleSweep, { passive: true });
    var wrap = document.querySelector('.page-wrapper');
    if (wrap) wrap.addEventListener('scroll', scheduleSweep, { passive: true });
  }

  function initHeader() {
    var header = document.getElementById('header-component') || document.querySelector('header');
    if (!header) return;
    var wrap = document.querySelector('.page-wrapper');
    var ticking = false;
    function scrolled() {
      var y = Math.max(window.scrollY || 0, wrap ? wrap.scrollTop : 0);
      return y > 10;
    }
    function update() {
      header.classList.toggle('lb-scrolled', scrolled());
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrap) wrap.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function boot() {
    initReveal();
    initHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
